import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { decryptText } from "../../utils/cipherText";
import UserTable from "./UserTable";
import TableFooter from "../../components/TableFooter";
import { FiDownload, FiFilter } from "react-icons/fi";
import DatePicker from "react-datepicker";
import { MdOutlineCancel } from "react-icons/md";
import { sideBarContext } from "../../App";

function KycStatus() {
  const divRef = useRef(null);
  const selectref = useRef(null);
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [pledgedAvailable, setPledgedAvailable] = useState(true);

  const [kycFilter, setKYCFilter] = useState("all");
  const [searchValue, setSearchValue] = useState(
    sessionStorage.getItem("kyc_search") || ""
  );
  const [noOfRows, setNoOfRows] = useState(0);
  const [noOfPages, setNoOfPages] = useState(10);
  const [startIndex, setStartIndex] = useState(0);

  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [endIndex, setEndIndex] = useState(rowsPerPage);

  const [filterApplied, setFilterApplied] = useState("");
  const [openAdvancedFilter, setOpenAdvancedFilter] = useState(false);
  const [advancedStartDate, setAdvancedStartDate] = useState("");
  const [advancedEndDate, setAdvancedEndDate] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const { expanded } = useContext(sideBarContext);

  const clearFilters = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setAdvancedStartDate("");
    setAdvancedEndDate("");
    setFilterApplied("");
    setOpenAdvancedFilter(false);
  };

  const handleStartDateChange = (date) => {
    const dateFormat = new Date(date);
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0");
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    setFilterApplied("");
    setAdvancedStartDate(ans);
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    const dateFormat = new Date(date);
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0");
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    setFilterApplied("");
    setAdvancedEndDate(ans);
    setSelectedEndDate(date);
  };
  const disableDateRanges = selectedStartDate
    ? [{ start: new Date(0), end: new Date(selectedStartDate - 1) }]
    : [];

  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  const handlePageDownload = async () => {
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/download_users_excel?page_name=users&status=${kycFilter}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);

      if (res.data.download_url) {
        handleDownloadFile(res.data.download_url);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickOutside = (event) => {
    if (selectref.current && selectref.current.contains(event.target)) {
      return;
    }
    if (divRef.current && !divRef.current.contains(event.target)) {
      setOpenAdvancedFilter(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[20px] pt-[16px] transition-all ease-in-out duration-100`}
    >
      <div className="bg-white h-24 px-4 flex flex-col justify-between pt-4 rounded-lg">
        <p className="text-xl font-semibold">KYC Status</p>
        <div className="text-sm space-x-8">
          <button
            className={`${
              kycFilter === "all"
                ? "border-b-[3px] border-[#212b36] font-semibold"
                : ""
            } py-[12px]`}
            onClick={() => {
              setPageNo(1);
              setKYCFilter("all");
            }}
          >
            All
          </button>
          <button
            className={`${
              kycFilter === "completed"
                ? "border-b-[3px] border-[#212b36] font-semibold"
                : ""
            } py-[12px]`}
            onClick={() => {
              setPageNo(1);
              setKYCFilter("completed");
            }}
          >
            KYC Completed
          </button>
          <button
            className={`${
              kycFilter === "incompleted"
                ? "border-b-[3px] border-[#212b36] font-semibold"
                : ""
            } py-[12px]`}
            onClick={() => {
              setPageNo(1);
              setKYCFilter("incompleted");
            }}
          >
            KYC Incomplete
          </button>
        </div>
      </div>
      <div className="px-4 mt-[16px] pt-[16px] flex justify-between items-center bg-white rounded-t-lg">
        <p className="text-base font-bold">All users</p>
        <div className="flex flex-row items-center gap-x-4 relative">
          <div className="relative">
            <div
              className={`rounded p-1 cursor-pointer text-white flex items-center ${
                filterApplied
                  ? "bg-[#00394D]"
                  : "border-[#DADADA] border border-solid"
              }`}
              ref={selectref}
              onClick={() => setOpenAdvancedFilter(!openAdvancedFilter)}
            >
              <FiFilter
                size={"17px"}
                color={filterApplied ? "#ffffff" : "#656565"}
              />{" "}
              <span className={`${filterApplied && "ml-1"} text-[14px]`}>
                {filterApplied && " ( 1 )"}
              </span>
            </div>
            {openAdvancedFilter && (
              <div
                ref={divRef}
                className="w-[190px] px-2 rounded-b-lg absolute top-[100%] right-[0%] z-10 bg-white pt-[12px] text-xs font-medium shadow-md pb-2"
              >
                <p className="text-sm font-bold text-[#262626] mb-2">
                  Filter by
                </p>
                <div className="flex flex-col gap-2 mt-2">
                  <p className="text-xs font-semibold text-[#262626]">
                    Start date
                  </p>
                  <DatePicker
                    selected={selectedStartDate}
                    onChange={handleStartDateChange}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
                    dateFormat="dd/MM/yyyy"
                    placeholderText="DD/MM/YYYY"
                  />
                  <p className="text-xs font-semibold text-[#262626]">
                    End date
                  </p>
                  <DatePicker
                    selected={selectedEndDate}
                    onChange={handleEndDateChange}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
                    dateFormat="dd/MM/yyyy"
                    placeholderText="DD/MM/YYYY"
                    excludeDateIntervals={disableDateRanges}
                  />
                </div>
                <div className="flex w-full justify-between items-center">
                  <button
                    type="button"
                    className={`py-[3px] px-2 rounded w-[46%] h-8 font-medium bg-[#00394d] text-white mt-3`}
                    onClick={() => {
                      if (advancedStartDate !== "" && advancedEndDate !== "") {
                        setFilterApplied("true");
                        setOpenAdvancedFilter(false);
                      }
                    }}
                  >
                    Filter
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      clearFilters();
                    }}
                    className="py-[3px] px-2 rounded w-[46%] h-8 font-medium text-[#00394d] border border-[#00394d] mt-3"
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="flex items-center px-3 ">
            <input
              type="search"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => {
                setPageNo(1);
                setSearchValue(e.target.value);
              }}
              className="w-[210px] text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px] focus:outline-none"
            />
          </div>
          <div className="flex">
            {userType !== "distributors" && (
              <button
                className="text-sm font-semibold py-[6px] px-4 flex items-center bg-[#00394d] text-white rounded"
                onClick={handlePageDownload}
              >
                <span className="mr-2">
                  <FiDownload />
                </span>
                Download
              </button>
            )}
          </div>
        </div>
      </div>
      <UserTable
        searchValue={searchValue}
        rowsPerPage={rowsPerPage}
        pageNo={pageNo}
        totalPages={noOfPages}
        setEndIndex={setEndIndex}
        status={kycFilter}
        setTotalRows={setNoOfRows}
        setTotalPages={setNoOfPages}
        advancedStartDate={advancedStartDate}
        advancedEndDate={advancedEndDate}
        filterApplied={filterApplied}
      />
      <div className="bg-white rounded-b-lg">
        <TableFooter
          totalPages={noOfPages}
          totalRows={noOfRows}
          rowsPerPage={rowsPerPage}
          startIndex={startIndex}
          setStartIndex={setStartIndex}
          setEndIndex={setEndIndex}
          endIndex={endIndex}
          setPageNo={setPageNo}
          pageNo={pageNo}
          setRowsPerPage={setRowsPerPage}
        />
      </div>
    </div>
  );
}

export default KycStatus;
